import styled from 'styled-components';

/**
 * Dark-theme lockup: the WHITE masked mark + wordmark. Shown only on the dark
 * theme and when not forced to the light treatment. On the light theme (or when
 * `$dark` forces a light surface) it hides in favour of {@link LightLockup}.
 */
export const Lockup = styled.div<{ $dark?: boolean }>`
  display: ${({ $dark }) => ($dark ? 'none' : 'flex')};
  align-items: center;
  gap: 14px;

  :root[data-ows-theme='light'] & {
    display: none;
  }
`;

/**
 * Light-theme lockup: a single purpose-built dark-on-light SVG (mark + wordmark),
 * so the brand reads on a white header instead of the white lockup vanishing.
 * Shown on the light theme, and when `$dark` forces the light treatment on a
 * light surface inside the dark theme (e.g. the in-app preview overlay).
 */
export const LightLockup = styled.img<{ $dark?: boolean }>`
  display: ${({ $dark }) => ($dark ? 'block' : 'none')};
  height: 32px;
  width: auto;
  flex-shrink: 0;

  :root[data-ows-theme='light'] & {
    display: block;
  }
`;

/**
 * Newton's logo on the dark theme (white wordmark), shown in place of
 * {@link Lockup} under the `n_showcase` preference; the light side reuses
 * {@link LightLockup} with Newton's dark-ink copy. Same 32px height as the
 * Whitelabels.com lockup.
 */
export const NewtonLockup = styled.img<{ $dark?: boolean }>`
  display: ${({ $dark }) => ($dark ? 'none' : 'block')};
  height: 32px;
  width: auto;
  flex-shrink: 0;

  :root[data-ows-theme='light'] & {
    display: none;
  }
`;

export const Mark = styled.div<{ $mask: string }>`
  height: 32px;
  width: 28.105px;
  flex-shrink: 0;
  mask-image: ${({ $mask }) => $mask};
  -webkit-mask-image: ${({ $mask }) => $mask};
  mask-repeat: no-repeat;
  -webkit-mask-repeat: no-repeat;
  mask-size: 28px 32px;
  -webkit-mask-size: 28px 32px;

  img {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

export const Wordmark = styled.img`
  height: 11px;
  width: 156px;
  flex-shrink: 0;
`;
